<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Badge } from '@smatch/cassiopeia-web-components';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let allowsPartialBids: boolean = false;

    // Plugins
    import { t } from 'svelte-i18n';

</script>

{#if allowsPartialBids}
    <Badge
        color = 'secondary'
        style = 'outline'
        size = 'md'
        description = { $t('component.auction.global.partial_bids_description') }
    >
        { $t('component.auction.global.partial_bids') }
    </Badge>
{:else}
    <Badge
        color = 'quaternary'
        style = 'outline'
        size = 'md'
        description = { $t('component.auction.global.full_bids_description') }
    >
        { $t('component.auction.global.full_bids') }
    </Badge>
{/if}